import { createAction, props } from '@ngrx/store';
import { FeatureFlagsEnum, Solution, ComponentNameMapping, LevelNameMapping } from '@twaice-fe/shared/models';
import { CustomerConfiguration } from '../../../types/customer-configuration';
// Technical slicing rather than domain slicing for store means module boundaries can't be enforced.
// eslint-disable-next-line twaice/no-types-import
import { LoadConfigSuccessPayload } from '../types/config.types';

export const loadFeatureFlagsSuccess = createAction(
  '[Config/Feature flags] Load configs Success',
  props<{ featureFlags: string[] | FeatureFlagsEnum[] }>()
);

export const loadSolutionConfigSuccess = createAction(
  '[Config/Solutions] Load configs success',
  props<{ solutions: Solution[] }>()
);

export const loadConfigSuccess = createAction('[Config] Load configs success', props<LoadConfigSuccessPayload>());

export const internalUIConfigChanged = createAction('[Config] Internal UI config changed');

export const useCustomerNamingChanged = createAction(
  '[Config] Use customer naming changed',
  props<{ useCustomerNaming: boolean }>()
);

export const loadNameMappingSuccess = createAction(
  '[Config] Load name mapping success',
  props<{
    customerBk: string;
    systemBk: string;
    componentNameMapping: ComponentNameMapping;
    levelNameMapping: LevelNameMapping;
  }>()
);
export const loadNameMappingFailure = createAction(
  '[Config] Load name mapping failure',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any }>()
);

export const fetchCustomerConfiguration = createAction('[Config] Fetch Customer Configuration', props<{ customerBk: string }>());
export const fetchCustomerConfigurationSuccess = createAction(
  '[Config] Fetch Customer Configuration Success',
  props<CustomerConfiguration>()
);
export const fetchCustomerConfigurationError = createAction(
  '[Config] Fetch Customer Configuration Error',
  props<{ error: string }>()
);
